import React, { useEffect, useState } from 'react'
import { postData } from '../../services/api'
import PieChart from "highcharts-react-official";
import Highcharts from 'highcharts/highstock'
Highcharts.setOptions({
    lang: {
        thousandsSep: ','
    }
});
export default function CustomerTypePercent() {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const getData = async () => {
        setIsLoading(true)
        const res = await postData('dashboard/back/sale-statistic-by-customer-type-percent')
        if (res.status === true) {
            setData(res.result)
            setIsLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [])
    return (
        <>
            <div class="row">
                <div class="col-sm-12 d-flex justify-content-center">
                    <h2 className='dash-title'>
                        การจำหน่ายผ่านช่องทางต่าง ๆ
                    </h2>

                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    {!isLoading && <Dashboard dataDashboard={data} />}
                </div>
            </div>
        </>
    )
}

function Dashboard({ dataDashboard }) {

    const color = [
        '#004aad',
        '#8c52ff',
        '#c332e1',
        '#9d0592',
        '#9d0303',
        '#800020',
    ]
    const data = dataDashboard?.map((x, i) => {
        return {
            name: x?.CustomerType,
            y: +x?.SoldPercent?.toFixed(2),
            SoldQty: +(+x?.SoldQty / 1000)?.toFixed(2),
            color: color[i]
        }
    })

    const options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: null,
            style: {
                display: 'none'
            }
        },

        exporting: { enabled: false },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },

        tooltip: {
            // pointFormat: '<b>{point.y} %</b>'
            pointFormatter: function () {
                var point = this,
                    series = point.series;

                return `<b>ร้อยละ:</b> ${point.y?.toLocaleString()} %<br/><b>ตัน:</b> ${point.SoldQty?.toLocaleString()}`
            },
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                // size: 80,
                allowPointSelect: true,
                innerSize: 120,
                borderWidth: 2,
                cursor: 'pointer',
                dataLabels: {
                    formatter: function () {
                        return `<div style="display: flex;align-items: center; border-bottom: 1px solid #e7e7e7 "><img src='/assets/images/user.png' width='12' height='12'/><span style="font-size:12px; margin-left: 5px; color:${this.color}">${this.key}</span></div><span style="font-size:10px;">${this.y}%</span>`
                        // return `<div style="display: flex;align-items: center; border-bottom: 1px solid #e7e7e7 "><img src='/assets/images/user.png' width='16' height='16'/><span style="font-size:16px; margin-left: 10px; color:${this.color}">${this.key}</span></div><span style="font-size:12px;">${this.y}%</span>`
                    },
                    enabled: true,
                    useHTML: true,
                }
            }
        },
        series: [{
            name: 'seasons',
            data: data,
            type: 'pie'
        }]
    }
    return (
        <>
            {dataDashboard && <PieChart options={options} highcharts={Highcharts} />}
        </>

    )
}
